import { filter } from "lodash";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import moment from 'moment';

import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { retry } from "redux-saga/effects";
import { contractWriteResponse, contractWriteHistory, companyListCall, postBuyWrite } from "../../crud/auth.crud"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import FileUploads from "../../components/RopikCustom/FileUploads";
import Util from "pages/Dashboard/Common/Util";

// import images
import loading from "../../assets/images/loading.gif";
import index from "pages/Blog/BlogGrid";
import { hover } from "@testing-library/user-event/dist/hover";

const style = {backgroundColor: "#ffffff", padding: "0.3rem", cursor: "pointer", width: 240};

const hoverStyle = {backgroundColor: "#48C3B1", color: "#ffffff", width: 240};

const BuyRequestWrite = () => {
  const selector = useSelector(state => state)
  const history = useHistory()

  const [title, setTitle] = useState('');
  const [rightBtnText, setRightBtnText] = useState('');
  const [rightBtnDisabled, setRightBtnDisabled] = useState(true);
  const [imgArr, setImgArr] = useState([]);
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [isDateTimePickerVisible, setIsDateTimePickerVisible] = useState(false);
  const [subjectToRecycling, setSubjectToRecycling] = useState('compost');
  const [id, setId] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [onUpload, setOnUpload] = useState(false);
  const [page, setPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [pricePerKg, setPricePerKg] = useState(0);
  const [qty, setQty] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [previewImages, setPreviewImages] = useState([])

  const subjectToRecyclingArr = [
    { 'key' : 'compost', 'text' : '퇴비'},
    { 'key' : 'feed', 'text' : '사료'},     
    { 'key' : 'wasteoil', 'text' : '폐유'},        
  ]

  const handleWrite = async () => {
    setOnUpload(true)

    try {
        const fd = new FormData();

        for(let i=0 ;i<imgArr.length; i++){
          fd.append('file_'+i, imgArr[i]);
        }

        const companyData = selector.auth?.user?.member_group?.[0]?.company_group;
        const member = selector.auth?.user;
        const tradeData = {   
            company : companyData?.id,
            member : member.id,
            address : companyData.address1 + ' ' + companyData.address2 || '',
            subject : subject,
            content : content,
            product_type : subjectToRecycling,
            price_per_kg: parseInt(pricePerKg),
            // price : parseInt(price),
            qty : parseInt(qty),
            type : 'buy',
            state : 'N',
            status : 'Y',
        }            
        fd.append('trade_data', JSON.stringify(tradeData))

        const response = await postBuyWrite(fd);
        if(response.data?.result === 'success'){ 
          setOnUpload(false)
          alert(response.data.msg)
            // SimpleToast.show(response.data.msg, SimpleToast.SHORT);
            // this.props.route?.params?.handleTabIndex(0)                  
            // this.props.route?.params?.handleRefresh(true)
            // await this.props.navigation.navigate('TradeScreen', {
            //     refresh : true,                          
            // });
        }else{
          setOnUpload(false)
        }             
       
    } catch (e) {
      setOnUpload(false)
      console.log(e)
    }
  }

  const deleteImage = (index) => {    
    setImgArr(imgArr.filter((v, i) => { return i !== index;}))    
    setPreviewImages(previewImages.filter((v, i) => { return i !== index;}))
  }

  const handleFileChange = (event) => {
    const files = event.target.files;
    let prevTmp = [];
    for (let i = 0; i < files.length; i++) {
      let item = {
        name : files[i].name,
        path :  URL.createObjectURL(files[i]),        
      }
      prevTmp.push(item)
    }
    let tmp = [...imgArr, ...event.target.files];
    tmp = tmp.filter((v, i) => {return i - 5 < 0})    
    setImgArr(tmp)    
    prevTmp = prevTmp.filter((v, i) => {return i - 5 < 0})
    setPreviewImages(prevTmp);
  };
  
  useEffect(()=>{
    setTotalPrice(pricePerKg * qty)
  }, [pricePerKg, qty])

  return (
    <React.Fragment>
      <div className="page-content">
      <MetaTags>
        <title>구매 등록 / 웨이스트버스</title>
      </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="상품 리스트" breadcrumbItem="구매 등록" />

          <Row>
            <Col xs="12" style={{maxWidth: '28rem'}}>
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody style={{padding: 24}}>
                  <div onClick={()=>{history.goBack()}}
                    style={{padding: '0.4rem 1rem', borderRadius: '0.2rem', marginBottom: 24, fontSize: 16}}
                    className="btn btn-primary dropdown-toggle waves-effect waves-light bg-silver"
                  >목록으로
                  </div>
                    <div style={{marginBottom: 24}}>
                      <p style={{color: '#333', fontSize: 16, lineHeight: "24px", fontWeight: 'bold', marginBottom: 8}}>상품명(제목)</p>
                      <input className="is-untouched is-pristine av-invalid form-control" style={{flexGrow: 1}} placeholder="상품명을 입력해주세요" onChange={(e) => {
                        if(e.target.value.length > 0){
                          setSubject(e.target.value);
                        }else{
                          setSubject('')
                        }
                      }} />
                    </div>
                    <div style={{marginBottom: 24, alignItems: "center"}}>
                      <p style={{color: '#333', fontSize: 16, lineHeight: "24px", fontWeight: 'bold', marginBottom: 8}}>상품 종류</p>
                      {   
                      subjectToRecyclingArr && subjectToRecyclingArr.map((item, index) => { return (
                        <div className="form-check form-check-inline" key={item.key + '_' + index}>
                          <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="subjectToRecycling" value={item.key} onChange={()=>{
                            setSubjectToRecycling(item.key)}} />
                          <label className="form-check-label mb-0" htmlFor={item.key} >{item.text}</label>
                        </div>
                      )})
                      }
                    </div>
                    <FileUploads title={'상품이미지'} arr={previewImages} handleChange={handleFileChange} handleDelete={deleteImage} />
                    <div style={{marginBottom: 24}}>
                      <p style={{color: '#333', fontSize: 16, lineHeight: "24px", fontWeight: 'bold', marginBottom: 8}}>상세 설명</p>
                      <textarea className="is-untouched is-pristine av-invalid form-control" style={{flexGrow: 1, height: 86}} placeholder="상품 상세 설명을 입력해주세요" onChange={(e) => {
                        if(e.target.value.length > 0){
                          setContent(e.target.value);
                        }else{
                          setContent('')
                        }
                      }} />
                    </div>
                    <div style={{marginBottom: 24}}>
                      <p style={{color: '#333', fontSize: 16, lineHeight: "24px", fontWeight: 'bold', marginBottom: 8}}>Kg당 가격 (원)</p>
                      <input className="is-untouched is-pristine av-invalid form-control" style={{flexGlow: 1, textAlign: "right"}} value={pricePerKg === 0 ? '' : Util.setPrice(pricePerKg)} placeholder="가격을 입력해주세요" onChange={(e) => {
                        e.target.value.length == 0 ? setPricePerKg(0) : setPricePerKg(e.target.value.replace(/,/g, ''));
                      }} />
                    </div>
                    <div style={{marginBottom: 24}}>
                      <p style={{color: '#333', fontSize: 16, lineHeight: "24px", fontWeight: 'bold', marginBottom: 8}}>구매량 (Kg)</p>
                      <input className="is-untouched is-pristine av-invalid form-control" style={{flexGlow: 1, textAlign: "right"}} value={qty === 0 ? '' : Util.setPrice(qty)} placeholder="구매량을 입력해주세요" onChange={(e) => {
                        e.target.value.length == 0 ? setQty(0) : setQty(e.target.value.replace(/,/g, ''));
                      }} />
                    </div>
                    <p className="font-weight-bold font-size-16 text-black text-right mb-4">총가격 <span className="font-size-24 text-warning">{Util.setPrice(totalPrice)}</span> 원</p>
                    
                    <div className="d-flex justify-content-end">
                    <Button
                      type="button"
                      color="primary"
                      style={{padding: '0.4rem 1rem', borderRadius: '0.2rem', fontSize: 16}}
                      onClick={() => {
                        handleWrite()
                      }}
                      >
                      등록하기
                    </Button>
                    </div>

                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {onUpload && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default BuyRequestWrite
